export const MESSAGE_BANNER_TYPES = {
	NOTICE: 0,
	INFO: 1,
	WARNING: 2,
	ERROR: 3,
	CRITICAL: 4,
	SUCCESS: 5,
};
